<div class="connection-status" 
     [class]="getStatusClass()"
     (mouseenter)="showTooltip = true"
     (mouseleave)="showTooltip = false">
  <span class="status-icon">{{ getStatusIcon() }}</span>
  
  <div class="tooltip" *ngIf="showTooltip">
    <div class="tooltip-content">
      <strong>{{ getStatusText() }}</strong>
      <p class="tooltip-detail">Status: {{ connectionState }}</p>
    </div>
  </div>
</div>
